import { inject } from 'inversify';
import { appendToFormData, urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';
import { IBranchInspection } from '../interfaces';
import { BranchInspectionMapper } from '../mappers';

export type ICreateBranchInspectionRepoResponse = IRepoResponse<200, IBranchInspection> | IRepoResponse<400 | 422 | 500, string>;

export type ICreateBranchInspectionRepo = IRepo<[{ branch_id: number; note?: string; deadline?: string }], ICreateBranchInspectionRepoResponse>;

export const CreateBranchInspectionRepoType = Symbol.for('CreateBranchInspectionRepo');

@bind(CreateBranchInspectionRepoType)
export class CreateBranchInspectionRepo implements ICreateBranchInspectionRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(data: { branch_id: number; note?: string; deadline?: string }) {
    try {
      const body = new FormData();
      appendToFormData(data, body);

      const url = urlMaker('/api/admin/branch_inspections');

      const result = await this.httpClient.post({ url, body });

      if (result.status === 200 || result.status === 201) {
        const inspection: IBranchInspection = BranchInspectionMapper.toDomain(result.data.data);

        return {
          status: 200 as 200,
          response: inspection,
        };
      } else if (result.status === 422) {
        const errors = result.data.errors;
        const errorMessage = Object.values(errors).flat().join(', ');

        return {
          status: 422 as 422,
          response: errorMessage || 'Validasiya xətası',
        };
      } else {
        return {
          status: 400 as 400,
          response: result.data.message || 'Yoxlanış yaradıla bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
